/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { ICONS } from "src/app/core/constants/icons";
import { HeaderService } from "src/app/core/services/header.service";
import { Router } from "@angular/router";
import { DialogService } from "src/app/core/services/dialog.service";
import { ShopItem } from "src/app/core/models/entites/shop/shopItem";
import { ShopState } from "src/app/features/shop/state/shop-state";
import { getShopItemsCount } from "src/app/features/shop/state/reducer/shop.reducer";

@Component({
  selector: "app-shop-tabs",
  templateUrl: "./shop-tabs.component.html",
  styleUrls: ["./shop-tabs.component.scss"]
})

export class ShopTabsComponent implements OnInit {

  protected INFO_GRAY = ICONS.INFO_GRAY;

  $shopItems: Observable<ShopItem[] | undefined> | undefined;
  $shopItemCount: Observable<number> = this.shopStore.pipe(select(getShopItemsCount));
  cartCountVisible = false;

  constructor(private shopStore: Store<ShopState>,
    protected headerService: HeaderService,
    private router: Router,
    private dialogService: DialogService) {

  }

  ngOnInit(): void {
    this.$shopItemCount.subscribe((cartCount: number) => {
      this.cartCountVisible = cartCount != 0;
    });
  }

  navigateToMyCart() {
    if (this.cartCountVisible)
      this.router.navigate(["/max-prodavnica/moja-korpa"]);
  }

  openInfoModal() {
    this.dialogService.openConfirmation("", this.headerService.currentNavBar!.infoMessage, false);
  }
}
